import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "m13.975 14.464.052-.589h.094a1.12 1.12 0 0 0 1.098-1.03l.289-3.521a1.49 1.49 0 0 0-1.11-1.58l-1.163-.296a2.46 2.46 0 0 0 .932-2.732A2.4 2.4 0 0 0 11.884 3 2.4 2.4 0 0 0 9.6 4.716a2.46 2.46 0 0 0 .932 2.731l-1.163.296v.001a1.49 1.49 0 0 0-1.109 1.58l.288 3.52a1.12 1.12 0 0 0 1.1 1.032h.093l.052.588C7.499 14.938 6 16.16 6 17.625 6 19.55 8.53 21 11.885 21s5.884-1.45 5.884-3.375c0-1.465-1.498-2.687-3.794-3.161M11.885 4.5a.92.92 0 0 1 .85.579.95.95 0 0 1-.2 1.022.91.91 0 0 1-1.002.203.94.94 0 0 1-.568-.867.93.93 0 0 1 .92-.937M9.727 9.199l2.158-.55 2.158.55-.26 3.177h-.091a1.106 1.106 0 0 0-1.098 1.023l-.278 3.101h-.863l-.276-3.101a1.107 1.107 0 0 0-1.099-1.023h-.09zM11.885 19.5c-2.735 0-4.414-1.092-4.414-1.875 0-.585.905-1.306 2.457-1.66l.059.671A1.476 1.476 0 0 0 11.453 18h.863c.762.003 1.4-.59 1.466-1.364l.059-.67c1.552.353 2.457 1.074 2.457 1.66 0 .782-1.678 1.874-4.413 1.874"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }